<template>
  <div class="workflow-form">
    <baseFrame
      save-text=""
      cancel-text=""
      clear-text=""
      submit-text=""
      :infos-arr="infos"
      :id="id + ''"
      id-text="审批流ID">
      <div slot="content">
        <lk-card class="mb16" title="当前审批流信息">
          <lk-form
            label-position="right"
            :label-width="114">
            <lk-row :gutter="16">
              <lk-col span="7">
                <lk-form-item label="审批流名称:">
                  <span>{{formModel.name}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span="7" offset="1">
                <lk-form-item label="状态:">
                  <span>{{statusMap.get(formModel.status)}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="适用门店:" prop="storeIdList">
                  <span>{{formModel.storeIdNameListStr}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="适用单据:">
                  <span>{{formModel.bizTypeNameListStr}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="审批级别:">
                  <span>{{formModel.allNode}}级</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="23">
                <lk-form-item label="角色设置:" prop="roleList">
                  <div id="step-background" class="workflow-step step-background">
                    <div class="ivu-steps ivu-steps-horizontal">
                      <div class="ivu-steps-item ivu-steps-status-wait"
                           v-for="(item, index) in stepList"
                           :key="index"
                           :style="{width: (1 / stepList.length * 100) + '%'}">
                        <div class="ivu-steps-tail"><i></i></div>
                        <div class="ivu-steps-head">
                          <div class="ivu-steps-head-inner">
                            <span class="iconfont">&#xe640;</span>
                          </div>
                        </div>
                        <div class="ivu-steps-main">
                          <div class="ivu-steps-title">{{item.title}}</div>
                          <div class="ivu-steps-content">
                            <span>{{item.roleName}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
        <lk-card title="版本信息" v-if="id">
          <lk-table border :columns="columns" :data="tableData"></lk-table>
        </lk-card>
      </div>
    </baseFrame>
    <!-- 未完成的单据 start -->
    <lk-modal
      v-model="listRecord.visiable"
      :mask-closable="false"
      :title="'审批流名称：'+ listRecord.name + '  版本号：' + listRecord.version"
      width="900">
      <div style="position: relative;">
        <loadingSpin v-show="modalLoading"></loadingSpin>
        <lk-table
          lk-table
          class="mb16"
          border
          min-height="400"
          max-height="500"
          :columns="billsColumn"
          :data="billsTableData">
        </lk-table>
        <div style="text-align:right">
          <lk-page
            :total="count"
            :current="page"
            :page-size="size"
            size="small"
            show-sizer
            show-total
            show-elevator
            transfer
            @on-change="handlePage"
            @on-page-size-change="handlePageSize">
          </lk-page>
        </div>
      </div>
      <div slot="footer">
        <div class="queryItem">
          <lk-button @click="listRecord.visiable = false">关闭</lk-button>
        </div>
      </div>
    </lk-modal>
    <!-- 未完成的单据 end -->
  </div>
</template>
<script>
import baseFrame from '../../components/frame/BaseFrame.vue';
import workflow from '../../services/workflow';
import system from '../../services/system';
import utils from '../../libs/utils';
import loadingSpin from '../../components/LoadingSpan';

export default {
  name: 'WorkflowInfo',
  components: {
    baseFrame,
    loadingSpin,
  },
  data() {
    return {
      id: '',
      infos: [],
      stepList: [],
      modalLoading: false,
      statusMap: new Map([
        [1, '启用'],
        [2, '禁用'],
      ]),
      roleList: [],
      formModel: {
        name: null,
        status: 2, // 默认禁用
        storeIdList: [],
        bizTypeList: [],
        allNode: null,
        // roleList: null,
      },
      page: 1,
      size: 10,
      count: 0,
      params: {},
      columns: [
        {
          title: '版本号',
          key: 'versionStr',
          width: 80,
        },
        {
          title: '审批流名称',
          key: 'name',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '适用门店',
          key: 'storeIdNameListStr',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '适用单据',
          key: 'bizTypeNameListStr',
          minWidth: 116,
        },
        {
          title: '审批级别',
          key: 'allNode',
          minWidth: 116,
        },
        {
          title: '审批角色',
          key: 'workRoleNameListStr',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '状态',
          key: 'status',
          minWidth: 116,
          render: (h, { row }) => h('span', row.status === 1 ? '启用' : '禁用'),
        },
        {
          title: '未结束单据数',
          key: 'unFinishNum',
          minWidth: 116,
          render: (h, { row }) => {
            const vm = this;
            return row.unFinishNum ? h('a',
              {
                prop: {},
                style: {},
                on: {
                  click() {
                    vm.listRecord.visiable = true;
                    vm.listRecord.name = row.name;
                    vm.listRecord.version = row.versionStr;
                    vm.params.workId = row.id;
                    vm.handleQueryUnFinishData();
                  },
                },
              }, row.unFinishNum) : h('span', 0);
          },
        },
        {
          title: '创建时间',
          key: 'createTimeStr',
          minWidth: 116,
        },
        {
          title: '最后启用时间',
          key: 'lastEnableTimeStr',
          minWidth: 116,
        },
      ],
      tableData: [],
      listRecord: {
        visiable: false,
        name: '',
        version: '',
      },
      billsColumn: [
        {
          title: '序号',
          type: 'index',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '单据类型',
          key: 'workRecordBizTypeName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '当前节点',
          key: 'workRecordRoleName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '当前审批人',
          key: 'auditNameListStr',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '标题',
          key: 'workRecordTitle',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '门店名称',
          key: 'storeName',
          minWidth: 116,
          tooltip: true,
        },
        {
          title: '提交人',
          key: 'workRecordCreateUserName',
          minWidth: 116,
          tooltip: true,
        },
      ],
      billsTableData: [],
    };
  },
  computed: {},
  methods: {
    getData() {
      workflow.getWorkflowInfo({ code: this.id }).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.tableData = [];
          // 找到当前启用状态的数据
          let enableNum = 0;
          list.forEach((item) => {
            const params = item.workPermission;
            params.bizTypeList = item.bizTypeList;
            params.storeIdList = item.storeIdList;
            params.bizTypeNameListStr = item.bizTypeNameList && item.bizTypeNameList.join(';'); // 适用单据
            params.storeIdNameList = [];
            // 适用门店名称
            item.sysStoreList.forEach((store) => {
              params.storeIdNameList.push(store.name);
            });
            params.storeIdNameListStr = params.storeIdNameList.join(';');

            params.stepList = [];
            params.workRoleNameList = [];
            item.workRoleRelList.forEach((role) => {
              let roleName = '';
              this.roleList.forEach((roleItem) => {
                if (role.roleId === roleItem.id) {
                  roleName = roleItem.name;
                  params.workRoleNameList.push(roleName);
                }
              });

              params.stepList.push({
                title: `${role.node}级审批人`,
                roleId: role.roleId,
                roleName,
              });
            });
            params.unFinishNum = item.unFinishNum;
            params.roleList = params.workRoleNameList.length;
            params.workRoleNameListStr = params.workRoleNameList.join(';');
            params.versionStr = `v${params.version.toFixed(1)}`;
            params.createTimeStr = utils.formatTime(params.createTime);
            params.lastEnableTimeStr = utils.formatTime(params.lastEnableTime) || '-';

            // 启用的审批流
            if (params.status === 1) {
              enableNum++;
              this.formModel = utils.deepClone(params);
              this.stepList = this.formModel.stepList; // 角色设置
              this.setInfos(params);
            }
            this.tableData.push(params);
          });

          // 都是禁用
          if (enableNum === 0) {
            const firstFlow = utils.deepClone(this.tableData[0]);
            this.formModel = firstFlow;
            this.stepList = firstFlow.stepList;
            this.setInfos(firstFlow);
          }
          this.count = count;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getRoleList() {
      return new Promise((resolve) => {
        const params = {
          page: 1,
          size: 1000,
          status: 1, // 启用状态
        };
        system.roleList(params).then((res) => {
          if (res.data.status === 200) {
            this.roleList = res.data.data.list;
          } else {
            this.$Message.error(res.data.error);
          }
          resolve();
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    handleToList() {
      this.$router.push({
        name: 'workflowList',
      });
    },
    setInfos(item) {
      this.infos = [
        {
          name: '创建人:',
          value: item.createUserName,
        },
        // {
        //   name: '创建时间:',
        //   value: utils.formatTime(item.createTime),
        // },
        {
          name: '最后修改人:',
          value: item.modifiedUserName,
        },
        // {
        //   name: '最后修改时间:',
        //   value: utils.formatTime(item.modifiedTime),
        // },
      ];
    },
    handleQueryUnFinishData() {
      this.page = 1;
      this.size = 10;
      this.getunFinishData();
    },
    getunFinishData() {
      this.modalLoading = true;
      this.params.page = this.page;
      this.params.size = this.size;
      workflow.getWorkflowListRecord(this.params).then((res) => {
        if (res.data.status === 200) {
          const { count, list } = res.data.data;
          this.billsTableData = [];
          list.forEach((item) => {
            const result = {};
            utils.exchangeTable(item, result);
            result.auditNameListStr = result.auditNameList && result.auditNameList.join(';');
            this.billsTableData.push(result);
          });
          this.count = count;
          this.modalLoading = false;
          this.listRecord.visiable = true;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this.modalLoading = false;
        utils.handleError(err);
      });
    },
    handlePageSize(val) {
      this.size = val;
      this.getunFinishData();
    },
    handlePage(val) {
      this.page = val;
      this.getunFinishData();
    },
  },
  created() {
    Promise.all([this.getRoleList()]).then(() => {
      if (this.$route.params && this.$route.params.id) {
        this.id = decodeURI(this.$route.params.id);
      }
      if (this.id) {
        this.getData();
      }
    });
  },
};
</script>
<style lang="less" scoped>
</style>
